import React from 'react';
import { Tag } from '@eb/eds-tag';
import shuffle from 'lodash/shuffle';
import gettext from '@eb/gettext';

import { TagGroup } from './TagGroup';

export const TagSuggestions = (props) => {
    const handleTagClick = (val) => {
        const path = window.location.pathname;
        const pathForTracking = path.replace(/(d\/.*?\/)(.*)/, `$1%23${val}/`);

        props.trackGAEvent({
            action: 'BreadcrumbTag',
            label: pathForTracking,
        });

        window.scroll(0, 0);
        props.handleApplyFilterSimple({ q: `#${val}` });
    };

    if (props.suggestedTags.length < 3) {
        return null;
    }

    return (
        <TagGroup
            containerClassName="pivot-section suggested-tags"
            suggestedItems={shuffle(props.suggestedTags)}
            headerText={gettext('Popular tags')}
            render={(tag) => {
                return (
                    <div className="eds-l-mar-all-1" key={tag.value}>
                        <Tag
                            style="outlined"
                            onActiveToggle={() => handleTagClick(tag.value)}
                        >
                            #{tag.display}
                        </Tag>
                    </div>
                );
            }}
        />
    );
};
